import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import Button from "theme/components/atoms/Button";
import EnhanceSubscribeToInStockAlert from "./EnhanceSubscribeToInStockAlert";
import { Email } from "theme/components/atoms/Form/Input";
import Spinner from "theme/components/atoms/Spinner";
import { InlineAlert } from "theme/components/molecules/Alert";
import { FormattedMessage } from "react-intl";

const messages = defineMessages({
  subscribeToInStockAlert: {
    id: "modules.SubscribeToInStockAlert.subscribe.title",
    defaultMessage: "Notify me when the product is back in stock",
  },
  unsubscribeToInStockAlert: {
    id: "modules.SubscribeToInStockAlert.unsubscribe.title",
    defaultMessage: "Don't notify me when the product is back in stock anymore",
  },
  connect: {
    id: "modules.SubscribeToInStockAlert.connect",
    defaultMessage: "Connect us, or enter your email",
  },
});

const SubscribeBtn = ({
  commandPending,
  email,
  isLogged,
  subscribeToInStockAlert,
  isSubscribedToInStockAlert,
  unsubscribeToInStockAlert,
  intl,
}) => (
  <Button
    state={commandPending ? "pending" : !isLogged && !email ? "disabled" : null}
    appearance="primary"
    size="big"
    onClick={(event) => {
      if (!isLogged && email) {
        subscribeToInStockAlert(email);
      } else {
        isSubscribedToInStockAlert
          ? unsubscribeToInStockAlert()
          : subscribeToInStockAlert();
      }
    }}
  >
    {intl.formatMessage(
      isSubscribedToInStockAlert
        ? messages.unsubscribeToInStockAlert
        : messages.subscribeToInStockAlert
    )}
  </Button>
);
const SubscribeToInStockAlert = ({
  subscribeToInStockAlert,
  unsubscribeToInStockAlert,
  isSubscribedToInStockAlert,
  commandPending,
  commandResponse,
  isLogged,
  loading,
  setPopinState,
}) => {
  const [email, setEmail] = useState("");
  const intl = useIntl();

  if (loading) {
    return <Spinner />;
  }
  return (
    <div className="subscribe-to-in-stock-alert">
      {!isLogged && commandResponse?.success !== true && (
        <>
          <span> {intl.formatMessage(messages.connect)}</span>
          <Email
            name="email"
            value={email}
            onChange={(inputValue) => {
              setEmail(inputValue);
            }}
            placeholder="martin.dupont@exemple.fr"
            className="customer-email"
          />
        </>
      )}

      {!commandResponse ? (
        <SubscribeBtn
          commandPending={commandPending}
          email={email}
          isLogged={isLogged}
          subscribeToInStockAlert={subscribeToInStockAlert}
          isSubscribedToInStockAlert={isSubscribedToInStockAlert}
          unsubscribeToInStockAlert={unsubscribeToInStockAlert}
          intl={intl}
        />
      ) : commandResponse.success === false ? (
        <>
          <InlineAlert withIcon appearance="error">
            <FormattedMessage
              id="modules.SubscribeToInStockAlert.subscribe.alreadySubscribe"
              defaultMessage="You've already subscribed to this stock alert or your email address is not valid"
            />
          </InlineAlert>
          <SubscribeBtn
            commandPending={commandPending}
            email={email}
            isLogged={isLogged}
            subscribeToInStockAlert={subscribeToInStockAlert}
            isSubscribedToInStockAlert={isSubscribedToInStockAlert}
            unsubscribeToInStockAlert={unsubscribeToInStockAlert}
            intl={intl}
          />
        </>
      ) : (
        <>
          <InlineAlert withIcon appearance="success">
            <FormattedMessage
              id="modules.SubscribeToInStockAlert.subscribe.success"
              defaultMessage="Your request has been registered!"
            />
          </InlineAlert>
          <Button
            appearance="primary"
            size="big"
            onClick={(event) => {
              setPopinState(false);
            }}
          >
            <FormattedMessage
              id="modules.SubscribeToInStockAlert.subscribe.continue"
              defaultMessage="Continue shopping"
            />
          </Button>
        </>
      )}
    </div>
  );
};

export default EnhanceSubscribeToInStockAlert()(SubscribeToInStockAlert);
